<div class="is-flex is-column">

  <app-sidebar-card (click)="toggle(expander)">
    <div class="is-flex gap-8 is-align-center">
      <app-sidebar-card-icon [name]="RoomsAssets[room.type].icon"></app-sidebar-card-icon>
      <app-sidebar-card-label>{{ room.name }}</app-sidebar-card-label>
    </div>

    <div class="is-flex gap-16 is-align-center">
      <app-sidebar-card-expand [id]="room.id" #expander></app-sidebar-card-expand>
    </div>
  </app-sidebar-card>


  <div [@expand]="expander.open ? 'open' : 'close'" class="measure-cards">
    <app-cp-compare-room-temperature [id]="room.id"></app-cp-compare-room-temperature>
    <app-cp-compare-room-rain [id]="room.id"></app-cp-compare-room-rain>
    <app-cp-compare-room-pressure [id]="room.id"></app-cp-compare-room-pressure>
    <app-cp-compare-room-noise [id]="room.id"></app-cp-compare-room-noise>
    <app-cp-compare-room-humidity [id]="room.id"></app-cp-compare-room-humidity>
    <app-cp-compare-room-co2 [id]="room.id"></app-cp-compare-room-co2>
    <app-cp-compare-room-boiler-on [id]="room.id"></app-cp-compare-room-boiler-on>
    <app-cp-compare-room-heating-power-request [id]="room.id"></app-cp-compare-room-heating-power-request>
    <app-cp-compare-room-wind-strength [id]="room.id"></app-cp-compare-room-wind-strength>
    <app-cp-compare-room-gust-strength [id]="room.id"></app-cp-compare-room-gust-strength>
  </div>

</div>